import { toast } from "react-toastify";
import { API_PRESUPUESTOS } from "../views/MainLayout/components/shared/services/presupuestos";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialPresupuestos = []

export const presupuestosReducer = (state = initialPresupuestos, action) => {
    switch(action.type){
        case "presupuestos/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchPresupuestos = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_PRESUPUESTOS.getPresupuestos(page, search)
        const data = await response.data;
        dispatch({ type: 'presupuestos/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const updatePresupuestosState = (presupuestosOldState, presupuestoId, ticketId = null) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const newPresupuestosArr = presupuestosOldState.presupuestos.map(pres => (
                pres.id === presupuestoId 
                    ? {...pres, ticket_id: ticketId}
                    : pres));
        dispatch({ type: 'presupuestos/fullfilled', payload: {
                ...presupuestosOldState,
                presupuestos: newPresupuestosArr
        } })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}